app.factory("odmRecommendService", function($q, $http, serverConfig, serverMessage) {
    var _apiUrl = serverConfig.apiUrl;
    var _defaultLogData = {
        "medicalAge"       : 30,
        "medicalGender"    : 0,
        "medicalType"      : 3,
        "medicalSystolic"  : 110,
        "medicalDiastolic" : 70,
        "medicalPulse"     : 70,
        "medicalHeight"    : 165,
        "medicalWeight"    : 55,
        "medicalFat"       : 15,
        "medicalAoF"       : null,
        "medicalMM"        : null,
        "medicalEBM"       : null,
        "medicalBMI"       : 20.2,
        "medicalVFLvl"     : null,
        "medicalBMR"       : null,
        "medicalBA"        : 2000,
        "medicalRBC"       : 480,
        "medicalHt"        : 43,
        "medicalHb"        : 15,
        "medicalBUN"       : 15,
        "medicalUA"        : 5,
        "medicalCRE"       : 0.8,
        "medicalTG"        : 100,
        "medicalHDL"       : 50,
        "medicalLDL"       : 80,
        "medicalGOT"       : 20,
        "medicalGPT"       : 20,
        "medicalGTP"       : 35,
        "medicalSugar"     : 80,
        "medicalHbA1c"     : 4
    };
    var _msgEnables = {};
    function _nullToDefault(key, value) {
        var rs = value;
        if(value == null) {
           rs = _defaultLogData[key];
        };
        return rs;
    }
    return {
        getSendData: function( odmLogdata ) {
            //送信データ初期化
            var sd = {
    			"medicalAge" : null,
    			"medicalGender" : null,
    			"medicalType" : null,
    			"medicalSystolic" : null,
    			"medicalDiastolic" : null,
    			"medicalPulse" : null,
    			"medicalHeight" : null,
    			"medicalWeight" : null,
    			"medicalFat" : null,
    			"medicalAoF" : null,
    			"medicalMM" : null,
    			"medicalEBM" : null,
    			"medicalBMI" : null,
    			"medicalVFLvl" : null,
    			"medicalBMR" : null,
    			"medicalBA" : null,
    			"medicalRBC" : null,
    			"medicalHt" : null,
    			"medicalHb" : null,
    			"medicalBUN" : null,
    			"medicalUA" : null,
    			"medicalCRE" : null,
    			"medicalTG" : null,
    			"medicalHDL" : null,
    			"medicalLDL" : null,
    			"medicalGOT" : null,
    			"medicalGPT" : null,
    			"medicalGTP" : null,
    			"medicalSugar" : null,
    			"medicalHbA1c" : null
    		};
            //送信データをセット
    		angular.forEach(odmLogdata, function(value, key) {
    			if(key in sd) {
    				sd[key] = value;
    			}
            });
            _msgEnables = {
                "血圧データ" : true,
                "肝機能検査データ" : true,
                "BMIデータ" : true,
                "脂質検査データ" : true,
                "血糖検査データ" : true,
                "血液一般検査データ" : true,
                "尿酸検査データ" : true,
                "体脂肪率データ" : true
            };
            if(sd.medicalSystolic == null || sd.medicalDiastolic == null) {
                _msgEnables["血圧データ"] = false;
            }
            if(sd.medicalSugar == null || sd.medicalHbA1c == null) {
                _msgEnables["血糖検査データ"] = false;
            }
            if(sd.medicalGOT == null || sd.medicalGPT == null || sd.medicalGTP == null) {
                _msgEnables["肝機能検査データ"] = false;
            }
            if(sd.medicalHb == null) {
                _msgEnables["血液一般検査データ"] = false;
            }
            if(sd.medicalLDL == null || sd.medicalHDL == null || sd.medicalTG == null) {
                _msgEnables["脂質検査データ"] = false;
            }
            if(sd.medicalUA == null) {
                _msgEnables["尿酸検査データ"] = false;
            }
            if(sd.medicalBMI == null) {
                _msgEnables["BMIデータ"] = false;
            }
            if(sd.medicalFat == null) {
                _msgEnables["体脂肪率データ"] = false;
            }
            angular.forEach(sd, function(value, key) {
                sd[key] = _nullToDefault(key, value);
            });
            return sd;
        },
        getMsgEnables : function() {
            return _msgEnables;
        },
        getUserRecommend : function(sendData) {
            var deferred = $q.defer();
            var config = { "timeout" : 5000 };
            $http.post(_apiUrl+'/getUserRecommend.php', JSON.stringify(sendData), config).then(function(response) {
                var nodata = false;
                angular.forEach(response.data, function(value, key) {
                    if(!nodata) {
                        if(value == null) {
                            nodata = true;
                        }
                    }
                });
                if(!nodata) {
                   deferred.resolve(response);
                }
                else {
                    deferred.reject(serverMessage.nodata);
                }
            }).catch(function(e) {
                deferred.reject(serverMessage.timeout);
            });
            return deferred.promise;
        },
        getbalancefoodRecommend : function(param0, param1, param2) {
            var deferred = $q.defer();
            var sendData = {
                "param0" : param0,
                "param1" : param1,
                "param2" : param2
            };
            var config = {
                "timeout" : 5000
            };
            $http.post(_apiUrl+'/getBalanceFoodRecommend.php', JSON.stringify(sendData), config).then(function(response) {
                var nodata = false;
                angular.forEach(response.data, function(value, key) {
                    if(!nodata) {
                        if(value == null) {
                            nodata = true;
                        }
                    }
                });
                if(!nodata) {
                    deferred.resolve(response);
                }
                else {
                    deferred.reject(serverMessage.nodata);
                }
            }).catch(function(e) {
                deferred.reject(serverMessage.timeout);
            });
            return deferred.promise;
        }
	};
});
